<mat-form-field class="medium-field">
  <mat-label>Type of List</mat-label>
  <mat-select class="mat-primary" [(ngModel)]="isOfType" id="field-list-type-dropdown" (ngModelChange)="listTypeChange($event)">
    @for (isOfType of isOfTypes; track isOfType) {
      <mat-option
        [value]="isOfType"
        id="field-list-type-dropdown-{{isOfType}}"
        [disabled]="!isTypeOfListEnabled(isOfType) && editMode">
        <span>{{isOfType}}</span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>